import { resetBgWithoutCvMaskBySf } from '../SizeFaces/fs.js';
import { UtilF } from '../../../Util/F/Function/module/UtilF.js';

export function makeCvBpcfInMakerA(canvas, bpcf, sf) {
  const last_cv_bpcf = G.mp.maker.cv_bpcf(canvas);
  if (last_cv_bpcf) canvas.remove(last_cv_bpcf);
  return new Promise(function (resolve) {
    const toUrl = UtilF.isLegacyMobile() ? G.to_900 : G.mp.maker.url;
    fabric.Image.fromURL(toUrl(G.mp.maker.url(bpcf.url)), function (img) {
      img.set({
        selectable: false,
        evented: false,
        globalCompositeOperation: 'destination-over',
        _data: { cv_type: 'cv_bpcf', is_not_design: true },
      });
      resetBgWithoutCvMaskBySf(img, sf);
      canvas.add(img);
      canvas.renderAll();
      resolve();
    });
  });
}
